export function setDecimals(value, decimals) {
  const valueAsFloat = parseFloat(value) // `toFixed` only works on floats
  return valueAsFloat.toFixed(decimals) // `toFixed` rounds to specified num of decimals
}

export function decimalsInValue(value) {
  const decimals = value.toString().split('.')[1]
  return decimals ? decimals.length : 0
}
